import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'
import type {
  ProductManage,
  ResOrganDominantItem,
  ResThirdPlatform,
  AnyObj
} from '@/apis/interface/marketingSystem'
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 查询当前机构认证主体
export const queryOrganDominant = (): Promise<ResOrganDominantItem[]> =>
  request.get<ResOrganDominantItem[]>('/admin/tenant/current/main/effect', {}, jsonHeaderConfig)

// 查询机构获客平台
export const queryOrganPlatformList = (): Promise<ResThirdPlatform[]> =>
  request.post<ResThirdPlatform[]>('/product/platform/product/customizeInfo', {}, jsonHeaderConfig)

// 推广产品-新增产品
export const saveProduct = (data: Recordable) =>
  request.post('/product/organProduct/save', data, jsonHeaderConfig)

// 校验商机产品开关
export const getBusinessSwitch = () => request.get('/product/organProduct/get/business/switch', {})

// 商品修改简化参数
export const updateProduct = (data: Recordable) =>
  request.post('/product/organProduct/save', data, jsonHeaderConfig)

// 推广产品-推广设置
export const saveTuiguangConfig = (data: ProductManage.ReqSaveProductStepTwo) =>
  request.post('/product/organProduct/setting', data, jsonHeaderConfig)

// 推广产品-数据统计项
export const getProductStatis = (data: any): Promise<ProductManage.ResProductStatis> =>
  request.post<ProductManage.ResProductStatis>(
    '/product/organProduct/statistics',
    data,
    jsonHeaderConfig
  )

// 推广产品-产品列表
export const queryProductList = (
  data: ProductManage.ReqProductListSearch
): Promise<ProductManage.ProductItem[]> =>
  request.post<ProductManage.ProductItem[]>('/product/organProduct/page', data, jsonHeaderConfig)

// 推广产品-删除产品
export const deleteProduct = (productId: string) =>
  request.get('/product/organProduct/productDelete', { productId })

// 推广产品-产品详情
export const queryProductDetail = (data: {
  productId: string
}): Promise<ProductManage.ReqSaveProduct> =>
  request.get<ProductManage.ReqSaveProduct>('/product/organProduct/detail', data, jsonHeaderConfig)

// 推广产品-平台推广开关
export const setPlatformSwitch = (data: ProductManage.ReqPlatformSwitch) =>
  request.post<ResThirdPlatform[]>('/product/organProduct/platform/switch', data, jsonHeaderConfig)

// 推广产品-放款城市和资质条件判断产品评级
export const matchLevel = (data: AnyObj) =>
  request.post<AnyObj>('/product/productRule/matchLevel', data, jsonHeaderConfig)

// 查询机构产品配置信息
export const queryOrganProductConfig = (): Promise<{
  openWechatCustom: number
}> =>
  request.get<{ openWechatCustom: number }>(
    '/product/productRule/queryConfig',
    {},
    jsonHeaderConfig
  )

// 查询可购买的流量包产品
export const getFlowPackageProduct = () =>
  request.get('/product/organProduct/flowPackageBuyList', {}, jsonHeaderConfig)

// 购买流量包产品
export const buyFlowPackageProduct = (data: { accountId: string; flowPackageId: string }) =>
  request.post('/ryh-product/flowPackageOrder/buy', data, jsonHeaderConfig)

// 获取流量包产品详情
export const getFlowPackageProductDetail = (data: { productId: string }) =>
  request.get('/product/organProduct/flowPackageDetail', data, jsonHeaderConfig)

// 联盟产品-精准产品-产品城市排名
export const productRankListApi = (data: AnyObj) =>
  request.post<AnyObj>('/product/organProduct/productRankList', data, jsonHeaderConfig)
// 联盟产品-精准产品-产品配置
export const productConfigApi = (data?: any) =>
  request.post<AnyObj>('/product/organProduct/productConfig', data, jsonHeaderConfig)
// 联盟产品-精准产品-产品推广总开关
export const productSwitchApi = (data: AnyObj) =>
  request.get<AnyObj>('/product/organProduct/productSwitch', data)

// 联盟产品-精准产品-城市获客底价
export const productCityMinPriceApi = (data: AnyObj) =>
  request.post<AnyObj>('/product/productRule/cityMinPrice', data, jsonHeaderConfig)

// B端判断机构是否存在普通精准产品
export const organIsExistNormalProductApi = () =>
  request.get<boolean>('/product/organProduct/exist/normal/accurate', {})

// 车主校验价格
export const carOwnerCheckPrices = (data: Recordable) =>
  request.post('/product/productRule/carOwnerCheckPrice', data, jsonHeaderConfig)

// 获取产品默认logo
export const getProductDefaultLogo = () => request.get('/product/organProduct/defaultLogo', {})

// 产品订单流量预估
export const getTrafficScope = (data: AnyObj) =>
  request.post<AnyObj>('/product/organProduct/orderFlow', data, jsonHeaderConfig)

// 出价排名
export const getProductRanking = (data: AnyObj) =>
  request.post<number>('/product/organProduct/rankRange', data, jsonHeaderConfig)

// 获取建议价
export const getSuggestPrice = (data: AnyObj) =>
  request.post<number>('/product/organProduct/suggestedPrice', data, jsonHeaderConfig)

// ------------------------------ 城市调价相关👇-------------------------
// 城市调价——弹窗查询
export const productPriceAdjustQuery = (id?: string) =>
  request.get<AnyObj>('/product/productPriceAdjust/popup/query', { id }, jsonHeaderConfig)

// 城市调价——一键调价
export const adjustCityPrice = (id: string) =>
  request.post<AnyObj>(`/product/productPriceAdjust/adjust/${id}`, {}, jsonHeaderConfig)

// 城市调价——下次提醒
export const adjustCityPriceConfirm = () =>
  request.post<AnyObj>(`/product/productPriceAdjust/popup/confirm`, {}, jsonHeaderConfig)

// 城市调价——弹窗关闭
export const adjustCityPriceClose = (id: string) =>
  request.post<AnyObj>(`/product/productPriceAdjust/popup/close/${id}`, {}, jsonHeaderConfig)
